// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\DispatchDashboard\DispatchDashboardViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { DispatchDashboardCorePermissions as _DispatchDashboardCorePermissions, DispatchDashboardCorePermissionsData as _DispatchDashboardCorePermissionsData, DispatchDashboardCorePermissionsOptions as _DispatchDashboardCorePermissionsOptions } from 'data/models/DispatchDashboard';
import { DispatchEvent, DispatchEventData, DispatchEventOptions } from 'data/models/DispatchEvent';
import { PilotAgency, PilotAgencyData, PilotAgencyOptions } from 'data/models/PilotAgency';
import { PilotJobOrder, PilotJobOrderData, PilotJobOrderOptions } from 'data/models/PilotJobOrder';
import { PilotJobOrderUserPreferences, PilotJobOrderUserPreferencesData, PilotJobOrderUserPreferencesOptions } from 'data/models/PilotJobOrderUserPreferences';
import { PilotsNavbar, PilotsNavbarData, PilotsNavbarOptions } from 'data/models/PilotsNavbar';
import { DispatchDashboardTab } from 'server/enums/DispatchDashboardTab';

// DispatchDashboardData is the class that DispatchDashboard serializes to/from
export interface DispatchDashboardData {
    From : /* ISO8601 */ string | null;
    Id : number;
    SearchQuery : string | null;
    Tab : DispatchDashboardTab;
    To : /* ISO8601 */ string | null;
	
    CorePermissions : _DispatchDashboardCorePermissionsData | null;
    DispatchEvents : DispatchEventData[] | null;
    JobOrders : PilotJobOrderData[] | null;
    Navbar : PilotsNavbarData | null;
    PilotAgency : PilotAgencyData | null;
    PilotJobOrderUserPreferences : PilotJobOrderUserPreferencesData[] | null;
	
    CanAcknowledgeIds : number[];
}

// DispatchDashboardOptions is the class which may be passed to the DispatchDashboard constructor to define optional initial data values
export interface DispatchDashboardOptions {
    From : /* ISO8601 */ string | null;
    Id : number;
    SearchQuery : string | null;
    Tab : DispatchDashboardTab;
    To : /* ISO8601 */ string | null;
	
    CorePermissions? : _DispatchDashboardCorePermissionsOptions | null;
    DispatchEvents? : DispatchEventOptions[] | null;
    JobOrders? : PilotJobOrderOptions[] | null;
    Navbar? : PilotsNavbarOptions | null;
    PilotAgency? : PilotAgencyOptions | null;
    PilotJobOrderUserPreferences? : PilotJobOrderUserPreferencesOptions[] | null;
	
    CanAcknowledgeIds? : number[];
}

export class DispatchDashboard {
    public From : DataSignal<TZDate | null>;
    public Id : DataSignal<number>;
    public SearchQuery : DataSignal<string | null>;
    public Tab : DataSignal<DispatchDashboardTab>;
    public To : DataSignal<TZDate | null>;
	
    public CorePermissions : DataSignal<_DispatchDashboardCorePermissions | null>;
    public DispatchEvents : SDataArray<DispatchEvent>;
    public JobOrders : SDataArray<PilotJobOrder>;
    public Navbar : DataSignal<PilotsNavbar | null>;
    public PilotAgency : DataSignal<PilotAgency | null>;
    public PilotJobOrderUserPreferences : SDataArray<PilotJobOrderUserPreferences>;
	
    public CanAcknowledgeIds : SDataArray<number>;

    constructor();
    constructor(data : DispatchDashboardOptions);
    constructor(data: DispatchDashboardOptions | null = null) {
        this.From = jsonableObservable(S.value<TZDate | null>(data && data.From !== undefined ? data.From === null ? null : new TZDate(data.From) : null, TZDate.nullableEq));
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.SearchQuery = jsonableObservable(S.value<string | null>(data && data.SearchQuery !== undefined ? data.SearchQuery : null));
        this.Tab = jsonableObservable(S.value<DispatchDashboardTab>(data && data.Tab !== undefined ? data.Tab : 0));
        this.To = jsonableObservable(S.value<TZDate | null>(data && data.To !== undefined ? data.To === null ? null : new TZDate(data.To) : null, TZDate.nullableEq));
	    
        this.CorePermissions = S.value<_DispatchDashboardCorePermissions | null>(null);
        this.DispatchEvents = SArray<DispatchEvent>([]);
        this.JobOrders = SArray<PilotJobOrder>([]);
        this.Navbar = S.value<PilotsNavbar | null>(null);
        this.PilotAgency = S.value<PilotAgency | null>(null);
        this.PilotJobOrderUserPreferences = SArray<PilotJobOrderUserPreferences>([]);
	    
        this.CanAcknowledgeIds = jsonableObservable(SArray<number>(data && data.CanAcknowledgeIds !== undefined ? data.CanAcknowledgeIds : []));
    }

    static key(obj : DispatchDashboard) {
        return (obj.From() === null ? '' : obj.From()!.toJSON()) + '\u2618' + obj.Id() + '\u2618' + (obj.SearchQuery() === null ? '\u2603' : obj.SearchQuery()!) + '\u2618' + obj.Tab() + '\u2618' + (obj.To() === null ? '' : obj.To()!.toJSON());
    }
    
    static dataKey(obj : DispatchDashboardOptions) {
        return (obj.From === null ? '' : new TZDate(obj.From).toJSON()) + '\u2618' + obj.Id + '\u2618' + (obj.SearchQuery === null ? '\u2603' : obj.SearchQuery) + '\u2618' + obj.Tab + '\u2618' + (obj.To === null ? '' : new TZDate(obj.To).toJSON());
    }

    static update(obj : DispatchDashboard, data : DispatchDashboardOptions) {
        S.freeze(() => {
            if (data.From !== undefined) obj.From(data.From === null ? null : new TZDate(data.From));
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.SearchQuery !== undefined) obj.SearchQuery(data.SearchQuery);
            if (data.Tab !== undefined) obj.Tab(data.Tab);
            if (data.To !== undefined) obj.To(data.To === null ? null : new TZDate(data.To));
	        
	        
            if (data.CanAcknowledgeIds !== undefined) obj.CanAcknowledgeIds(data.CanAcknowledgeIds);
        });
    }
}

// DispatchDashboardCorePermissionsData is the class that DispatchDashboardCorePermissions serializes to/from
export interface DispatchDashboardCorePermissionsData {
    Id : number;
	
	
    CanAddPilotJobOrders : boolean;
    CanExportSchedule : boolean;
    CanManageBills : boolean;
    CanManageDispatchEvents : boolean;
    CanReserveBerths : boolean;
}

// DispatchDashboardCorePermissionsOptions is the class which may be passed to the DispatchDashboardCorePermissions constructor to define optional initial data values
export interface DispatchDashboardCorePermissionsOptions {
    Id : number;
	
	
    CanAddPilotJobOrders? : boolean;
    CanExportSchedule? : boolean;
    CanManageBills? : boolean;
    CanManageDispatchEvents? : boolean;
    CanReserveBerths? : boolean;
}

export class DispatchDashboardCorePermissions {
    public Id : DataSignal<number>;
	
	
    public CanAddPilotJobOrders : DataSignal<boolean>;
    public CanExportSchedule : DataSignal<boolean>;
    public CanManageBills : DataSignal<boolean>;
    public CanManageDispatchEvents : DataSignal<boolean>;
    public CanReserveBerths : DataSignal<boolean>;

    constructor();
    constructor(data : DispatchDashboardCorePermissionsOptions);
    constructor(data: DispatchDashboardCorePermissionsOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
	    
        this.CanAddPilotJobOrders = jsonableObservable(S.value<boolean>(data && data.CanAddPilotJobOrders !== undefined ? data.CanAddPilotJobOrders : false));
        this.CanExportSchedule = jsonableObservable(S.value<boolean>(data && data.CanExportSchedule !== undefined ? data.CanExportSchedule : false));
        this.CanManageBills = jsonableObservable(S.value<boolean>(data && data.CanManageBills !== undefined ? data.CanManageBills : false));
        this.CanManageDispatchEvents = jsonableObservable(S.value<boolean>(data && data.CanManageDispatchEvents !== undefined ? data.CanManageDispatchEvents : false));
        this.CanReserveBerths = jsonableObservable(S.value<boolean>(data && data.CanReserveBerths !== undefined ? data.CanReserveBerths : false));
    }

    static key(obj : DispatchDashboardCorePermissions) {
        return obj.Id();
    }
    
    static dataKey(obj : DispatchDashboardCorePermissionsOptions) {
        return obj.Id;
    }

    static update(obj : DispatchDashboardCorePermissions, data : DispatchDashboardCorePermissionsOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.CanAddPilotJobOrders !== undefined) obj.CanAddPilotJobOrders(data.CanAddPilotJobOrders);
            if (data.CanExportSchedule !== undefined) obj.CanExportSchedule(data.CanExportSchedule);
            if (data.CanManageBills !== undefined) obj.CanManageBills(data.CanManageBills);
            if (data.CanManageDispatchEvents !== undefined) obj.CanManageDispatchEvents(data.CanManageDispatchEvents);
            if (data.CanReserveBerths !== undefined) obj.CanReserveBerths(data.CanReserveBerths);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/DispatchDashboard.ts